import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  InputBase,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  downloadBRSRDataReport,
  downloadGRIIndex,
  fetchBusinessUnits,
  getSettingPreferences,
} from "../../services/orgService";
import "./CreateReport.scss";
import { DatePicker, DatePickerProps } from "antd";
import { Moment } from "moment";
import {
  generateGRIYearwiseReport,
  generateReportService,
} from "../../services/emissionService";
import { toastMessage } from "../../helper";
import { successMessage } from "../../constants/messageConstants";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

const CreateReport = () => {
  const { t, i18n } = useTranslation();
  type RangeValue = [Moment | null, Moment | null] | null;

  const { RangePicker } = DatePicker;
  const [dates, setDates] = useState<RangeValue>(null);
  let [preferences, setPreferences] = useState<any>();
  const [formData, setFormData] = useState<any>({
    type: 29,
    typeName: t("Framework"),
    subType: 460,
    subTypeName: "ISO-14064-1",
    subTypes: [{ id: 460, name: "ISO-14064-1" }],
    uom: "kgCO2e",
  });
  const typeSubTypes = [
    {
      id: 29,
      name: t("Framework"),
      subTypes: [{ id: 460, name: "ISO-14064-1" }],
    },
    {
      id: 1844,
      name: t("Management"),
      subTypes: [
        { id: 1846, name: "Category Wise Breakdown" },
        { id: 1932, name: "Activity Wise - CO2e Breakdown" },
        { id: 3051, name: "Activity Wise - Data Breakdown" },
      ],
    },
    {
      id: 1001,
      name: t("Disclosure"),
      subTypes: [
        { id: 1000, name: "GRI" },
        { id: 1011, name: "GRI Index" },
        { id: 1012, name: "BRSR report" },
      ],
    },
  ];
  const { type, subType, typeName, subTypeName, uom } = formData;

  const disabledDate = (current: any) => {
    // console.log("start month:", startMonth);
    // console.log("end month : ", endMonth);
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], "year") >= 1;
    const tooEarly = dates[1] && dates[1].diff(current, "year") >= 1;
    return !!tooEarly || !!tooLate;
  };
  const onChangeObjective = (event: any) => {
    const typeData: any = typeSubTypes.find(
      (each: any) => each.id === parseInt(event.target.value)
    );
    setFormData({
      ...formData,
      type: parseInt(event?.target.value),
      typeName: typeData?.name,
      subType: typeData.subTypes[0].id,
      subTypeName: typeData.subTypes[0].name,
      subTypes: typeData?.subTypes,
    });
  };
  const onChangeSubType = (event: any) => {
    const typeData: any = typeSubTypes.find((each: any) => each.id === type);
    const subTypeData = typeData.subTypes.find(
      (each: any) => each.id === parseInt(event.target.value)
    );
    if (typeName == "Disclosure") {
      setStartMonth(null);
      setEndMonth(null);
    }
    setFormData({
      ...formData,
      subType: subTypeData.id,
      subTypeName: subTypeData.name,
    });
  };
  const onChangeUom = (event: any) => {
    const selectedUom = event.target.value;
    setFormData({
      ...formData,
      uom: selectedUom,
    });
  };
  const InputStyle = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      border: "none",
      height: "2.2rem !important",
      width: "11rem",
    },
  }));
  const monthFormat = "YYYY/MM";
  const [startMonth, setStartMonth] = useState<any>(
    new Date(new Date().getFullYear(), 0, 2)
  );
  const [endMonth, setEndMonth] = useState<any>(
    new Date(new Date().getFullYear(), 11, 31, 15)
  );
  const [businessUnits, setBusinessUnits] = useState([] as any[]);
  const [selectedBunits, setSelectedBunits] = useState<any>([]);
  const [scopes, setScopes] = useState([
    { id: 1, name: "Scope 1", selected: true },
    { id: 2, name: "Scope 2", selected: true },
    { id: 3, name: "Scope 3", selected: true },
  ]);
  const [managementReports, setManagementReports] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const onChangeDate = (e: any) => {
    if (!e) {
      setStartMonth(null);
      setEndMonth(null);
      return;
    }
    console.log(e);
    console.log(e[0].$d);
    let startDate = new Date(e[0].$d);
    console.log("startDate before", startDate);
    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 2);
    console.log("startDate after", startDate);
    console.log("startDate toString" + startDate.toDateString());
    setStartMonth(startDate);

    let endDate = new Date(e[1].$d);
    console.log("endDate before", endDate);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1);
    console.log("endDate after", endDate);
    setEndMonth(endDate);
    if (typeName == "Disclosure") {
      if (Math.abs(startDate.getFullYear() - endDate.getFullYear()) > 2) {
        toastMessage("Select a maximum of three years", "error");
        return;
      }
    }
    // setGlobFilters({ ...globFilters, from: startDate, to: endDate });
  };
  const [defaultDateRange, setDefaultRange] = useState<any>([]);
  const [showDateRange, setShowDateRange] = useState(false);
  useEffect(() => {
    getSettingPreferences(true).then((res) => {
      const companyData = res.data.companyPreference;
      if (companyData.is_calendar_year) {
        setDefaultRange([
          dayjs(new Date().getFullYear() + "/01/01", monthFormat),
          dayjs(new Date().getFullYear() + "/12/31", monthFormat),
        ]);
      } else {
        if (companyData.financial_year) {
          const dateRange = companyData.financial_year.split("to");
          let startMonth =
            (dateRange[0].trim().length === 1 ? "0" : "") + dateRange[0].trim();
          let endMonth =
            (dateRange[1].trim().length === 1 ? "0" : "") + dateRange[1].trim();
          setDefaultRange([
            dayjs(
              new Date().getFullYear() + "/" + startMonth + "/01",
              monthFormat
            ),
            dayjs(
              new Date().getFullYear() +
                1 +
                "/" +
                endMonth +
                "/" +
                new Date(
                  new Date().getFullYear() + 1,
                  Number(endMonth),
                  0
                ).getDate() +
                1,
              monthFormat
            ),
          ]);

          setStartMonth(
            new Date(new Date().getFullYear(), Number(startMonth) - 1, 2)
          );
          setEndMonth(
            new Date(
              new Date().getFullYear() + 1,
              Number(endMonth) - 1,
              new Date(
                new Date().getFullYear() + 1,
                Number(endMonth),
                0
              ).getDate() + 1
            )
          );
        }
      }
      setShowDateRange(true);
      const reqManagement = res.data.reports.filter((each: any) =>
        [1846, 1932, 3051].includes(each.id)
      );
      setManagementReports([...reqManagement]);
    });
  }, []);
  let disclosureReports = [
    { id: 1000, name: "GRI" },
    { id: 1011, name: "GRI Index" },
    { id: 1012, name: "BRSR report" },
  ];
  let [isAllocationFacilityPresent, setIsAllocationFacilityPresent] =
    useState(false);
  useEffect(() => {
    fetchBusinessUnits({}).then((res) => {
      const sortedBunits = res.data.businessUnits;
      sortedBunits.sort((a: any, b: any) => a.name.localeCompare(b.name));
      setBusinessUnits([...sortedBunits]);
      setPreferences(
        JSON.parse(localStorage.getItem("companyPreference") || "[]")
      );
      // setSelectedBunits(data.businessUnits)
      //console.log(bunitList);
    });
  }, []);

  const onOpenChange = (open: boolean) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const onYearChange = (event: any) => {
    let startMonth = new Date();
    startMonth.setFullYear(event.$y);
    setStartMonth(startMonth);
    setEndMonth(startMonth);
  };

  const handleBunitChange = (
    event: SelectChangeEvent<typeof businessUnits>
  ) => {
    console.log("selected bunits ", event.target.value);
    const {
      target: { value },
    } = event;
    if (preferences.allocationFacility) {
      setIsAllocationFacilityPresent(
        value
          .toString()
          .split(",")
          .filter((unit) => unit == preferences.allocationFacility.toString())
          .length == 1
      );
    } else {
      setIsAllocationFacilityPresent(
        !!businessUnits
          .filter((bu) =>
            value.toString().split(",").includes(bu.id.toString())
          )
          .filter((unit) => unit.code.substr(-2) == "F1")[0]?.id
      );
    }
    setSelectedBunits(value);
  };
  const onSelectScope = (e: any, index: number) => {
    let scopeList = scopes;
    scopeList[index].selected = e.target.checked;
    setScopes([...scopeList]);
  };

  const downloadReportFromBuffer = (res: any) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Report.xlsx"); //or any other extension
    document.body.appendChild(link);
    link.click();
    toastMessage(successMessage().GENERATE_SUCCESS, "success");
  };

  const downloadReport = () => {
    setIsLoading(true);
    let reqObj: any = {};
    if (selectedBunits.length) {
      reqObj.businessUnits = {
        ids: selectedBunits?.map((eachUnit: any) => eachUnit.toString()),
      };
      reqObj.bUnitNames = businessUnits
        ?.filter((eachUnit: any) => selectedBunits.includes(eachUnit.id))
        .map((eachUnit: any) => eachUnit.name)
        .toString();
    }
    reqObj.scopes = {
      ids: scopes
        ?.filter((eachScope: any) => eachScope.selected)
        .map((eachScope: any) => eachScope.id.toString()),
    };
    reqObj.from = startMonth;
    reqObj.to = endMonth;
    reqObj.type = type;
    reqObj.subType = subType;
    reqObj.isAllocationFacilityPresent = isAllocationFacilityPresent;
    reqObj.companyName = JSON.parse(localStorage.getItem("company") || "").name;
    reqObj.reporterName =
      JSON.parse(localStorage.getItem("user") || "").displayName ||
      JSON.parse(localStorage.getItem("user") || "").email;
    reqObj.email = JSON.parse(localStorage.getItem("user") || "").email;
    reqObj.mobile = JSON.parse(localStorage.getItem("user") || "").mobile;
    reqObj.typeName = typeName;
    reqObj.subTypeName = subTypeName;
    reqObj.uom = uom;
    if (reqObj.subTypeName == "GRI") {
      let years = [];
      let year = new Date(startMonth).getFullYear();
      while (year <= new Date(endMonth).getFullYear()) {
        years.push(year);
        year++;
      }
      reqObj.years = years;
      generateGRIYearwiseReport(reqObj)
        .then(async (res) => {
          downloadReportFromBuffer(res);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        });
    } else if (reqObj.subTypeName == "GRI Index") {
      downloadGRIIndex(startMonth.getFullYear())
        .then((res) => {
          downloadReportFromBuffer(res);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        });
    } else if (reqObj.subTypeName == "BRSR report") {
      let years = [startMonth.getFullYear()];
      reqObj.years = years;
      downloadBRSRDataReport(reqObj)
        .then((res) => {
          downloadReportFromBuffer(res);
        })
        .catch((error) => {
          let enc = new TextDecoder();
          toastMessage(
            JSON.parse(enc.decode(error.response.data)).message,
            "error"
          );
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        });
    } else {
      generateReportService(reqObj)
        .then(async (res) => {
          downloadReportFromBuffer(res);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        });
    }
  };
  const validForm = () => {
    return typeName != "Disclosure"
      ? startMonth &&
          endMonth &&
          scopes?.filter((eachScope: any) => eachScope.selected)?.length &&
          selectedBunits.length
      : startMonth &&
          endMonth &&
          Math.abs(startMonth.getFullYear() - endMonth.getFullYear()) <= 2;
  };
  return (
    <div className="flex justify-center items-center h-full bg-neutral-100 p-10 overflow-y-auto">
      <div className="flex pw-max-height-80vh pw-hide-scroll flex-col pw-report-main bg-white overflow-y-auto   p-5">
        <div className=" pw-report-field">
          <p className="pw-report-label">{t("Report Objective")}</p>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="radio"
            value={type}
            onChange={onChangeObjective}
            className="!flex !flex-row"
          >
            <FormControlLabel
              value={29}
              control={<Radio />}
              label={t("Framework")}
            />
            <FormControlLabel
              value={1844}
              control={<Radio />}
              label={t("Management")}
            />
            <FormControlLabel
              value={1001}
              control={<Radio />}
              label={t("Disclosure")}
            />
          </RadioGroup>
        </div>
        <div className="pw-report-field">
          {typeName === "Framework" && (
            <p className={`pw-usetiful-framework pw-report-label`}>
              {t("Type of")} {typeName}{" "}
            </p>
          )}
          {typeName === "Management" && (
            <p className={`pw-usetiful-management pw-report-label`}>
              {t("Type of")} {typeName}{" "}
            </p>
          )}
          <Select
            label={subTypeName}
            className="pw-report-select pw-e2e-reporttype"
            value={subType}
            onChange={onChangeSubType}
          >
            {typeName === "Framework"
              ? formData.subTypes.map((eachSubType: any) => (
                  <MenuItem value={eachSubType.id} key={eachSubType.id}>
                    {localStorage.getItem("protocol") == "ghg"
                      ? "GHGP"
                      : eachSubType.name}
                  </MenuItem>
                ))
              : typeName === "Management"
              ? managementReports.map((each: any) => (
                  <MenuItem value={each.id} key={each.id}>
                    {each.name}
                  </MenuItem>
                ))
              : disclosureReports.map((each: any) => (
                  <MenuItem value={each.id} key={each.id}>
                    {each.name}
                  </MenuItem>
                ))}
          </Select>
        </div>
        {typeName != "Disclosure" ? (
          <>
            <div className="pw-report-field">
              <p className="pw-report-label">{t("Facility")}</p>

              <Select
                multiple
                value={selectedBunits}
                label="Facility"
                placeholder="Select Facilities"
                className="pw-report-select pw-e2e-reportfacility"
                onChange={handleBunitChange}
                renderValue={(p) =>
                  p?.length > 0
                    ? (p.length === businessUnits?.length ? "All" : p.length) +
                      " " +
                      t("Facilities selected")
                    : t("Select Facilities")
                }
              >
                {businessUnits.map((each: any) => (
                  <MenuItem value={each.id} key={each.id}>
                    {each.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="pw-report-field">
              <p className="pw-report-label">{t("UoM")} </p>
              <Select
                label="UoM"
                className="pw-report-select pw-e2e-reportuom"
                value={uom}
                onChange={onChangeUom}
              >
                <MenuItem value="kgCO2e" key="kgCO2e">
                  {t("kg CO2e")}
                </MenuItem>
                <MenuItem value="tCO2e" key="tCO2e">
                  {t("t CO2e")}
                </MenuItem>
              </Select>
            </div>
            <div className="pw-report-field">
              <p className="pw-report-label">{t("Scope Selection")}</p>
              <div className="flex flex-row justify-between !w-full">
                {scopes.map((eachScope: any, index: number) => {
                  return (
                    <div
                      key={eachScope.id}
                      className={`flex flex-row items-center ${eachScope.name.replace(
                        /[.\s]/g,
                        ""
                      )}`}
                    >
                      <Checkbox
                        className={`${eachScope.name}`}
                        checked={eachScope.selected}
                        onChange={(e) => onSelectScope(e, index)}
                      />
                      <div>{eachScope.name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div className="pw-report-field">
          <p className="pw-report-label">{t("Duration")}</p>
          {showDateRange &&
            (typeName !== "Disclosure" ? (
              <RangePicker
                // value={dates || value}
                className="pw-report-select"
                // disabledDate={disabledDate}
                picker="month"
                onCalendarChange={(val: any) => {
                  setDates(val);
                }}
                onChange={onChangeDate}
                onOpenChange={onOpenChange}
                defaultValue={defaultDateRange}
                format={monthFormat}
              />
            ) : subTypeName == "GRI" ? (
              <RangePicker
                // value={dates || value}
                className="pw-report-select"
                picker="year"
                onCalendarChange={(val: any) => {
                  setDates(val);
                }}
                onChange={onChangeDate}
                onOpenChange={onOpenChange}
                defaultValue={defaultDateRange}
              />
            ) : (
              <DatePicker
                onChange={onYearChange}
                style={{ height: "40px", fontSize: "1.1rem" }}
                picker="year"
              ></DatePicker>
            ))}
        </div>
        {typeName == "Disclosure" ? (
          <>
            <div style={{ minHeight: "288px" }}></div>
          </>
        ) : (
          ""
        )}
        <div className="flex justify-end pt-2 pr-2">
          {/* <Button
            variant="outlined"
            // onClick={()}
            style={{
              border: "1px solid #3D4A5C",
              color: "#1D2025",
            }}
          >
            <text className="pw-cancelText"> Cancel</text>
          </Button> */}
          <div
            className={`!min-w-[6rem] pw-bunit-button-save text-white  
           ${
             validForm()
               ? isLoading
                 ? "text-black bg-neutral-300"
                 : "cursor-pointer bg-primary"
               : "text-black bg-neutral-300"
           }`}
            onClick={() => validForm() && !isLoading && downloadReport()}
          >
            {isLoading ? (
              <div className="flex flex-row gap-2 p-2">
                <span>{t("Downloading")}</span>
                <CircularProgress size={20} />
              </div>
            ) : (
              <span>{t("Download")}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateReport;
